import { useEffect, useState } from 'react';
import '../../assets/css/RestaurantsHome.css'
import { getLocationData } from '../../utils/AWSAPI';
import { useTranslation } from 'react-i18next';
import i18n from "../Translations/i18n/i18n";

function RestaurantsHome() {
  const { t } = useTranslation();

  const [store, setStore] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const loadLanguage = () => {
      const language = localStorage.getItem("language");
      if (language) {
        i18n.changeLanguage(language);
      }
    };
    loadLanguage();
  }, []);

  const handleButtonClick = (action) => {
    if(action === "list") {
      window.location.href = `restaurants`;
    } else {
      lookupLocation();
    }
  }

  const lookupLocation = async() => {
    let storeName = store;
    if (!storeName.startsWith("MCD")) {
      storeName = "MCD" + store;
    }
    const location = await getLocationData(storeName);
    if(location.Error) {
      setErrorMessage("Coulnd't find a restaurant by that name (" + storeName + ").");
      return;
    }
    window.location.href = `dashboard?location=` + location.SysID + "&locationName=" + storeName;
  }

  const handleChange = (event) => {
    setErrorMessage("");
    setStore(event.target.value);
  }

  return (
    <div className='App'>
      <div className="searchbox">
        <h1 className='searchbox-title'>{t('Self Service Portal')}</h1>
        {errorMessage && (
          <h4>{errorMessage}</h4>
        )}
        <input autoComplete="off" inputMode="search" placeholder={t('Search for a restaurant...')} type="search" onChange={handleChange}/>
      </div>
      <div className='searchbox-buttons'>
        <button className='searchbox-button' onClick={() => handleButtonClick("search")}>{t('Search')}</button>
        <button className='searchbox-button' onClick={() => handleButtonClick("list")}>{t('Go to Restaurant List')}</button>
      </div>
    </div>
  )
}

export default RestaurantsHome;